export enum SLIDESHOWS {
    logos = 'logos',
    projects = 'projects'
}
export enum TECH_CATEGORY {
    build = 'Build',
    cloud_computing = 'Cloud Computing',
    code_authoring = 'Code Authoring',
    code_quality = 'Code Quality',
    code_versioning = 'Code Versioning',
    collaboration = 'Collaboration',
    database = 'Database',
    deployment = 'Deployment',
    ecommerce = 'e-Commerce',
    front_end_framework = 'Front End Framework',
    identity = 'Identity',
    javascript = 'Javascript',
    language = 'Language',
    markup = 'Markup',
    networking = 'Networking',
    operating_system = 'Operating System',
    presentation = 'Presentation',
    server = 'Server',
    templating = 'Templating',
}
// These are all the keys for clients that are referenced as resume positions and portfolio items
export enum SITE_CLIENT {
    warner = 'warner',
    ciandt = 'ciandt',
    zillow = 'zillow',
    firstAm = 'firstAm',
    fashionnova = 'fashionnova',
    neocova = 'neocova',
    crocs = 'crocs',
    trilogyed = 'trilodyed',
    tenx = 'tenx',
    cybercoders = 'cybercoders',
    johndeere = 'johndeere',
    sears = 'sears',
    pathfinder = 'pathfinder', // orthogonal.io
    truven = 'truven', // merative.com
    icrossing = 'icrossing',
    tribune = 'tribune',
    ubs = 'ubs',
    usaf = 'usaf', // http://airforce.com
    abnAmro = 'abnAmro',
    ies = 'ies',
    xb = 'xb', // http://hiplink.com
    maytag = 'maytag',
    billwhitney = 'billwhitney',
    watts = 'watts',
    spectrum = 'spectrum',
    amex = 'amex', // http://americanexpress.com'
    ubsw = 'ubsw',
    quebecor = 'quebecor',
    giantstep = 'giantstep',
    loyola = 'loyola',
    sussex = 'sussex',
    cnmat = 'cnmat',
    ils = 'ils',
}
export enum GLOBALS {
    lastClient = SITE_CLIENT.ciandt,
    slideshowSpeed = 2000, // frequency of slide changes, in msec
    slideshowTransition = 500 // duration of slide transitiopn in msec
}
